export default function formAPIpendingvisits({
    patientname,
    chiefcomplaint,
    appointmentdate,
    patientimage,
    imagepath,
    appointmentid,
    patientid,
    appointmenttime,
    isaasign,
    assignstatusname
    
  }) {
   
  
    return Object.freeze({
        patientname: patientname,
        chiefcomplaint: chiefcomplaint,
        appointmentdate:appointmentdate,
        patientimage,
        imagepath,
        appointmentid,
    patientid,
    appointmenttime,
    isaasign,
    assignstatusname
    });
  }
  